module.exports = __webpack_public_path__ + "static/media/donuts.6dfd77aa.mkv";